import {
  getAllowedUserAdminRoleAssignments,
  getCanAssignUserAdminRoles,
  getCanRemoveAnswersTopics,
  getEditNetworkQuestionsSettingsStatus,
  getFeatureAccessSettings,
  getFeatureAccessSettingsStatus,
  getNetworkQuestionsEnablementMode,
} from '@ms/yammer-data/dist/domains/featureAccessSettings/selectors';
import { NetworkQuestionsEnablementMode } from '@ms/yammer-graphql';

import { useSelector } from '../useSelector';

type UseFeatureAccessSettings = () => ReturnType<typeof getFeatureAccessSettings>;
export const useFeatureAccessSettings: UseFeatureAccessSettings = () => useSelector(getFeatureAccessSettings);

type UseFeatureAccessSettingsStatus = () => ReturnType<typeof getFeatureAccessSettingsStatus>;
export const useFeatureAccessSettingsStatus: UseFeatureAccessSettingsStatus = () =>
  useSelector(getFeatureAccessSettingsStatus);

type UseNetworkQuestionsEnablementMode = () => NetworkQuestionsEnablementMode | undefined;
export const useNetworkQuestionsEnablementMode: UseNetworkQuestionsEnablementMode = () =>
  useSelector(getNetworkQuestionsEnablementMode);

type UseEditNetworkQuestionsSettingsStatus = () => ReturnType<typeof getEditNetworkQuestionsSettingsStatus>;
export const useEditNetworkQuestionsSettingsStatus: UseEditNetworkQuestionsSettingsStatus = () =>
  useSelector(getEditNetworkQuestionsSettingsStatus);

type UseCanRemoveAnswersTopics = () => ReturnType<typeof getCanRemoveAnswersTopics>;
export const useCanRemoveAnswersTopics: UseCanRemoveAnswersTopics = () => useSelector(getCanRemoveAnswersTopics);

type UseCanAssignUserAdminRoles = () => ReturnType<typeof getCanAssignUserAdminRoles>;
export const useCanAssignUserAdminRoles: UseCanAssignUserAdminRoles = () => useSelector(getCanAssignUserAdminRoles);

type UseAllowedUserAdminRoleAssignments = () => ReturnType<typeof getAllowedUserAdminRoleAssignments>;
export const useAllowedUserAdminRoleAssignments: UseAllowedUserAdminRoleAssignments = () =>
  useSelector(getAllowedUserAdminRoleAssignments);
